exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram3a3-6 #slots div[id]{height:174px}#diagram3a3-6 .element-list_drop,#diagram3a3-6 .fixed-answer{height:174px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/3/3a3/diagram6/diagram6.scss
// module id = 1162
// module chunks = 0